// extracted by mini-css-extract-plugin
export default {"ribbon":"Popular_ribbon__2Cy2L"};